import { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import { apiURL } from "../../config";

export type GroupType = "decision" | "user";

export type UserInput = {
	email: string;
	firstName: string;
	lastName: string;
	roleInOrganization: string;
	phone: string;
	website: string;
	officeAddress: string;
	privateAddress: string;
	about: string;
	username: string;
	password: string;
	roles: string[];
};

export interface UserType {
	isAdmin: boolean;
	id: number;
	username: string;
	email: string;
	firstName: string;
	lastName: string;
	roles: string[];
	phone: string;
	active: boolean;
	createdById?: number
	organizationUnits: OrganizationUnit[];
}

export interface OrganizationUnit {
	organizationUnit: OrganizationUnit2;
	roles: string[];
}

export interface OrganizationUnit2 {
	id: number;
	name: string;
}

export async function getUser(axiosPrivate: AxiosInstance, userId: number) {
	return axiosPrivate
		.get(`${apiURL}/admin/user/${userId}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			console.error(err);
			return Promise.reject(err);
		});
}

export async function getUsers(axiosPrivate: AxiosInstance, phrase = "", limit = 100, offset = 0) {
	return axiosPrivate
		.get(`${apiURL}/admin/user.json?phrase=${phrase}&limit=${limit}&offset=${offset}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			console.error(err);
			return Promise.reject(err);
		});
}

export async function postCreateUser(variables: { axiosPrivate: AxiosInstance; data: UserInput }) {
	const { axiosPrivate, data } = variables;
	return axiosPrivate
		.post(`${apiURL}/admin/user.json`, data)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("User - created");
				return res;
			} else {
				toast.error("User - failed to create");
			}
		})
		.catch((err) => {
			console.error(err);
			return err.response;
		});
}

export type ChangeUserPasswordInputType = {
	userId: number;
	newPassword: string;
};

export async function postChangeUserPassword(variables: { axiosPrivate: AxiosInstance; data: ChangeUserPasswordInputType }) {
	const { axiosPrivate, data } = variables;
	return axiosPrivate
		.post(`${apiURL}/admin/user/change-password/${data.userId}.json`, { newPassword: data.newPassword })
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("User password - changed");
				return res.data;
			} else {
				toast.error("User password - failed to change");
			}
		})
		.catch((err) => {
			console.error(err);
			return err.response;
		});
}

export async function deleteUser(variables: { axiosPrivate: AxiosInstance; userId: number }) {
	const { axiosPrivate, userId } = variables;
	return axiosPrivate
		.delete(`${apiURL}/admin/user/${userId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("User - deleted");
				return res;
			} else {
				toast.error("User failed to be deleted");
			}
		})
		.catch((err) => {
			console.error(err);
			return Promise.reject(err);
		});
}
